import {  RecoilRoot,
    atom,
    selector,
    useRecoilState,
    useRecoilValue} from 'recoil';

export const CompaniaAtom = atom({
    key: "CompaniaAtom",
    default:'',
});
export const SolicitudesAtom = atom({
    key: "SolicitudesAtom",
    default:[],
});
export const ReferidosAtom = atom({
    key: "ReferidosAtom",
    default:[],
});

export const ClienteCompaniaAtom = atom({
    key: 'ClienteCompaniaAtom',
    defaults:[]
})

export const TIPO_DOCUMENTO = {
    CEDULA: { value: "C", label: "Cedula" },
    RNC: { value: "R", label: "RNC" },
    PASAPORTE: { value: "P", label: "Pasaporte" },
};
export const DEFAULT_PAGINATION_VALUES = {
    EsPaginable: true,
    CantidadPorPagina: 15,
    EsOrdernable: true,
    OrderBy: "IdSec",
    EsAscendente: false,
};
export const PAIS_CODIGO_DO = "DO";
export const PAIS_CODIGO_EC = "EC";
export const PAIS_CODIGO_CR = "CR";
export const PAIS_CODIGO_GT = "GT";
export const PAIS_CODIGO_SV = "SV";

export const PAIS = [
    { value: PAIS_CODIGO_DO, label: "República Dominicana"},
    { value: PAIS_CODIGO_EC, label: "Ecuador" },
    { value: PAIS_CODIGO_CR, label: "Costa Rica" },
];

export const PLANES_ECF = [
    { value: "1kT", label: "1 - 1,000 transacciones", precio: 210 },
    { value: "5kT", label: "1,001 - 5,000 transacciones", precio: 545 },
    { value: "10kT", label: "5,001 - 10,000 transacciones", precio: 915 },
    { value: "25kT", label: "10,001 - 25,000 transacciones", precio: 1840 },
    { value: "50kT", label: "25,001 - 50,000 transacciones", precio: 2775 },
    { value: "100kT", label: "50,001 - 100,000 transacciones",precio: 3860 },
];

export const PLANES_ECF_GESTION_NEGOCIO = [
    { value: "1kT", label: "1 - 1,000 transacciones", precio: 85 },
    { value: "5kT", label: "1,001 - 5,000 transacciones", precio: 205 },
    { value: "10kT", label: "5,001 - 10,000 transacciones", precio: 335 },
    { value: "25kT", label: "10,001 - 25,000 transacciones", precio: 895 },
    { value: "50kT", label: "25,001 - 50,000 transacciones", precio: 950 },
    { value: "100kT", label: "50,001 - 100,000 transacciones",precio: 1070 },
]

export const FECHA_CIERRE_FISCAL = [
    { value: "A", label: "31 de Diciembre" },
    { value: "M", label: "31 de Marzo" },
    { value: "J", label: "30 de Junio" },
    { value: "S", label: "30 de Septiembre" },
];
export const TIPO_NCF_DO = [
    { value: "E", label: "Registro Regímenes Especiales de Tributación" },
    { value: "F", label: "Factura de Consumo" },
    { value: "B", label: "Comprobantes Gubernamentales" },
    { value: "C", label: "Factura Crédito Fiscal" },
    { value: "U", label: "Registro Único Ingreso" },
    { value: "P", label: "Comprobante para Exportaciones" },
    { value: "A", label: "Número Impresión Fiscal NIF" },
];
export const TIPO_NCF_EC = [
    { value: "N", label: "Régimen General" },
    { value: "R", label: "RIMPE Negocio Popular" },
    { value: "L", label: "RIMPE Emprendedor" },
    { value: "X", label: "Contribuyentes Régimen Especial" },
    { value: "S", label: "Personas naturales y sucesiones indivisas obligadas a llevar contabilidad" },
    { value: "I", label: "Agentes de Retención" },
    { value: "G", label: "Establecimientos gráficos autorizados" },
];

export const CONFIGURACION_OPCIONALES_FORMALIZACION_ACADEMICA = [
    { name: 'RRHH', value: 1 },
    { name: "Cierre de Caja", value: 2 },
    { name: "Centro de Costos", value: 3 },
]

export const tiposPago = [
    {name: 'Tarjeta', value: 0},
    {name: 'Tranferencia', value: 1},
    {name: 'Recurrente', value: 2}
]
export const modulosAdi = [
    { name: "Préstamos y Financiamiento", value: 5 },
    { name: "RRHH", value: 1 },
    { name: "Producción", value: 6 },
    { name: "POS Restaurante", value: 4 },
    { name: "Consulta Médica", value: 2 },
    { name: "Factoring", value: 3 },
];
export const CantidadTabletasPOSResturante = [
    { name: "1 tableta", value: 1, precio: 500, cantidad: 1 },
    { name: "5 tabletas", value: 2, precio: 2000, cantidad: 5 },
    { name: "10 tabletas", value: 3, precio: 3500, cantidad: 10 },
];

export const TERMINAL_TIPO_PT = "P";
export const integracionesDgii = [
    { name: "Facturación Electrónica", value: 1 },
];
export const CANCELACION_SERVICIO = [
    { name: "Citrus ERP", value: 1 },
    { name: "Citrus CRM", value: 2 },
    { name: "Citrus PT Comercios", value: 3 },
];
export const integracionesPanelFirma = [
    { name: "Cardnet POS", value: 1 },
    { name: "Portal POS", value: 2 },
    { name: "Azul POS", value: 3 },
];
export const integracionComernioElectronico = [
    { name: "Woo Commerce", value: 1 },
    { name: "Shopify", value: 2 },
    { name: "Mini Hotel", value: 3 },
];
export const integracionLinkPago = [
    { name: "CardNet Webservice", value: 1 },
    { name: "Azul Webservice", value: 2 },
];
export const USO_DATOS = [{ name: "1 GB (Gratis)", value: 1 }];
export const USO_CORREOS_MEN = [{ name: "1000 Correos (Gratis)", value: 1 }];

export const otrasConfig = [
    { name: "Cierre de Caja", value: 1 },
    { name: "Centro de Costos", value: 2 },
];

export const PLAN_REFERIDO= [
    {name: "25% de descuento en sus primeros tres meses de servicio.", value: 1},
    {name: "Primer mes renta gratis ", value: 2},
]
export const FUENTE_CUENTA = "X";

export const FUENTE_CASO = "A";

export const TIPO_COMPONENTE = {
    ATTACHMENTS: "Attachments",
    EVENTOS_FUTUROS: "EventosFuturos",
    TAREAS_FUTURAS: "TareasFuturas",
    CUENTA: "Cuenta",
    CUENTAS: "Cuentas",
    EQUIPOS: "Equipos",
    PERFILES: "Perfiles",
    CASOS: "Casos",
    LLAMADAS: "Lllamadas",
    OPORTUNIDAD: "Oportunidad",
    PROSPECTOS: "PROSPECTOS",
    OPORTUNIDADES: "Oportunidades",
    CONTACTOS: "Contactos",
    COTIZACIONES: "Cotizaciones",
    PROSPECTO: "Prospecto",
    BALANCE: "Balance",
    TOP_ITEM_VENDIDOS: "TopItemVendidos",
    RELOJ_TRABAJO: "RelojTrabajo",
    CASOS_RELACIONADOS: "CasosRelacionados",
};

export const TABLAS = {
    PROSPECTO: "Prospecto",
    CASO: "Caso",
    OPORTUNIDAD: "Oportunidad",
    CONTRATO: "Contrato",
    TAREA: "ActividadTarea",
    EVENTO: "ActividadEvento",
    LLAMADA: "ActividadLlamada",
    CUENTA: "Cliente",
    CONTACTO: "PersonaDeContacto",
    COTIZACION: "Cotizacion",
};

export const getTabla = (fuente) => {
    switch (fuente) {

        case FUENTE_CASO:
            return TABLAS.CASO;

        default:
            return "";
    }
};

export const TIPO_SOLICITUDES_MI_CUENTA = [
    { value: "E", label: "Entrenamiento" },
    { value: "S", label: "Soporte" },
]

export const TIPO_ENTRENAMIENTOS_MI_CUENTA = [
    { value: "P", label: "Presencial" },
    { value: "R", label: "Remoto" },
]

export const LOCALE_ES_GRID = {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
    monthNames: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ],
    monthNamesShort: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
    equals: "Igual a",
    notEquals: "Diferente a",
    lt: "Menor a",
    lte: "Menor o igual a",
    gt: "Mayor a ",
    gte: "Mayor o igual a",
    is: "Is",
    isNot: "Is Not",
    before: "Before",
    after: "After",
    apply: "Aplicar",
    matchAll: "Coincidir todo",
    matchAny: "Coincidir cualquiera",
    addRule: "Agregar condicion",
    removeRule: "Quitar condicion",
}
export const LOCALE_ES_DATEPICKER = {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    today: 'Hoy',
    clear: 'Limpiar'
}
export const PERIODOS_DDL = [
    { name: "Actual", value: 1 },
    { name: "Anterior", value: 2 },
    { name: "Otro", value: 3 },
];
export const PERIODOS_ACTUAL = [
    { name: "Hoy", value: 1 },
    { name: "Esta Semana", value: 2 },
    { name: "Este Mes", value: 3 },
    { name: "Este Trimestre", value: 4 },
    { name: "Este Año", value: 5 },
];
export const PERIODOS_ANTERIOR = [
    { name: "Ayer", value: 6 },
    { name: "Semana Anterior", value: 7 },
    { name: "Mes Anterior", value: 8 },
    { name: "Trimestre Anterior", value: 9 },
    { name: "Año Anterior", value: 10 },
]
export const MENSAJE_ERROR_SERVIDOR_USUARIO = "Error en el servidor, favor comunicarse con el administrador";
export const MENSAJE_ERROR_PERMISO = "Usuario no tiene este permiso";
